import { Menu } from '@flintmint/web-shared/components/menu';

import { useUserSource } from '@/hooks/rxdb-models';

import type { SlashMenuCommonProps } from '@/components/slash-menu';

export const UserSourceSlashMenu = (props: SlashMenuCommonProps) => {
  const { editor, className, forwardedRef, generateTextActive, makeGenerateTextMenuItem } = props;

  const { data: userSource } = useUserSource(editor.storage.documentInfo.documentId);

  const generateTextOption = makeGenerateTextMenuItem({ llmContext: { userSource } });

  return (
    <Menu
      className={className}
      data={[generateTextOption]}
      forwardedRef={forwardedRef}
      data-testid="cortex-slash-menu"
      onExitSubMenu={() => editor.view.focus()}
      initialActiveCustomView={generateTextActive ? generateTextOption : undefined}
    />
  );
};
